import axios from 'axios'

export default {
	namespaced: true,
	state: {
		token: localStorage.getItem('token') || '',
		status: null,
		name: localStorage.getItem('name'),
		roles: localStorage.getItem('roles'),
		user: ''
	},
	getters: {
		isLoggedIn: state => !!state.token,
		authStatus: state => state.status,
		userRoles: state => state.roles,
		user: state => state.user
	},
	mutations: {
		auth_request(state){
			state.status = 'loading'
		},
		auth_success(state, token){
			state.status = 'success'
			state.roles = token.roles.join(', ')
			state.user = token
			state.token = `Bearer ${token.access_token}`
		},
		auth_error(state){
			state.status = 'error'
		},
		logout_mut(state){
			state.status = ''
			state.token = ''
		},
		get_user_data(state, user){
			state.user = user
			console.log(user)
		},
	},
	actions: {
		login({ commit, rootState }, user) {
			return new Promise((resolve, reject) => {
				commit('auth_request')
				axios.post(`${rootState.api}token?username=${user.username}&password=${user.password}`, )
				.then(resp => {
						const user = resp.data
						localStorage.setItem('token', `Bearer ${user.access_token}`)
						localStorage.setItem('roles', user.roles.join(', '))
						localStorage.setItem('name', user.username)
						localStorage.setItem('userId', user.userId)
						axios.defaults.headers.common['Authorization'] = `Bearer ${user.access_token}`
						commit('auth_success', user)
						resolve(resp)
				})
				.catch(err => {
					commit('auth_error')
					localStorage.removeItem('token')
					localStorage.removeItem('roles')
					localStorage.removeItem('name')
					localStorage.removeItem('userId')
					reject(err)
				})
			})
		},
		logout({commit}) {
			return new Promise((resolve, reject) => {
				commit('logout_mut')
				localStorage.removeItem('token')
				localStorage.removeItem('roles')
				localStorage.removeItem('name')
                localStorage.removeItem('userId')
				delete axios.defaults.headers.common['Authorization']
				resolve()
			})
		},
		getUserData({commit, rootState}){
			axios.get(`${rootState.api}ManyRoles/CurrentUser`, ).then(resp => {
				const user = resp.data
				console.log(user)
				commit('get_user_data', user)
			})
		}
	}
};
